import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class PayrollConfigService {

    constructor(private api: ApiService) { }

    get(): Observable<any> {
        return this.api.get('hr/payroll-config');
    }

    update(payload: any): Observable<any> {
        return this.api.post('hr/payroll-config', payload);
    }

    getImssQuotaRates(): Observable<any> {
        return this.api.get('hr/payroll-config/imss-quota-rates');
    }
}
